import React from 'react';
import { useTranslate } from '@hooks';
import { camelCase, compact } from 'lodash';
import { toArray } from '@dotone/react-ui-core/utils';
import { FilterBlock, FilterList, BooleanFilterBlock } from '@dotone/react-ui-core';
import { AffiliateFilterBlock, OfferFilterBlock } from '../filters';

const CampaignFilterList = ({ full = false, filters, ...otherProps }) => {
  const { t } = useTranslate('campaign', 'model');
  const { tShared } = useTranslate('campaign');
  const {
    offerIds = [],
    affiliateIds = [],
    approvalStatuses = [],
    isCustomPayout,
    payScheduleFrom,
    payScheduleTo,
  } = filters;

  const translate = (nestedNs, items = []) => {
    return toArray(items).map((item) => tShared(`${nestedNs}.${camelCase(item)}`));
  };

  return (
    <FilterList {...otherProps}>
      <OfferFilterBlock ids={offerIds} />
      {full && <AffiliateFilterBlock ids={affiliateIds} />}
      <FilterBlock
        label={t('::common:model.status')}
        items={translate('approvalStatus', approvalStatuses)}
        list={false}
      />
      {full && (
        <>
          <BooleanFilterBlock label={t('isCustomPayout')} items={isCustomPayout} />
          <FilterBlock
            label={t('payScheduleExpiration')}
            items={[compact([payScheduleFrom, payScheduleTo]).join(' - ')]}
            list={false}
          />
        </>
      )}
    </FilterList>
  );
};

export default React.memo(CampaignFilterList);
